import React, { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogActions, Button, Alert,
  TextField, CircularProgress,
} from "@mui/material";
import axios from "../../../config/axiosConfig";
import { Encabezado, Seccion, Rejilla, fieldSx, contenidoSx, pieSx, botonPrincipalSx } from "./dialogoUi";

const isoFecha = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime()) || d.getFullYear() < 1950) return "";
  return String(value).slice(0, 10);
};

const EditarHistorialDialog = ({ open, onClose, registro, onGuardado }) => {
  const [form, setForm] = useState({ year: "", fecha: "", cantidad: "", observacion: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open && registro) {
      setForm({
        year: String(registro.year || ""),
        fecha: isoFecha(registro.fecha),
        cantidad: String(registro.cantidad ?? ""),
        observacion: registro.observacion || "",
      });
      setError("");
    }
  }, [open, registro]);

  const handleChange = (campo) => (e) => setForm((prev) => ({ ...prev, [campo]: e.target.value }));

  const puedeGuardar = form.year && form.fecha && form.cantidad !== "" && !saving;

  const handleGuardar = async () => {
    setSaving(true);
    setError("");
    try {
      await axios.patch(`/api/permisos/historial/${registro.id}`, {
        year: Number(form.year),
        fecha: form.fecha,
        cantidad: Number(form.cantidad),
        observacion: form.observacion.trim(),
      });
      onGuardado();
    } catch (e) {
      setError(e?.response?.data?.message || "Error al guardar los cambios.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth scroll="paper">
      <Encabezado titulo="Editar días ganados" subtitulo={`Registro #${registro?.id ?? ""}`} />
      <DialogContent sx={contenidoSx}>
        {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}
        <Seccion titulo="Registro">
          <Rejilla cols={2}>
            <TextField size="small" type="date" label="Fecha de registro" InputLabelProps={{ shrink: true }} value={form.fecha} onChange={handleChange("fecha")} sx={fieldSx} />
            <TextField size="small" type="number" label="Gestión" value={form.year} onChange={handleChange("year")} sx={fieldSx} />
            <TextField size="small" type="number" label="Días" value={form.cantidad} onChange={handleChange("cantidad")} sx={fieldSx} />
          </Rejilla>
          <TextField size="small" label="Observación" multiline minRows={2} fullWidth value={form.observacion} onChange={handleChange("observacion")} sx={{ ...fieldSx, mt: 1 }} />
        </Seccion>
      </DialogContent>
      <DialogActions sx={pieSx}>
        <Button onClick={onClose} disabled={saving} sx={{ textTransform: "none" }}>Cancelar</Button>
        <Button variant="contained" onClick={handleGuardar} disabled={!puedeGuardar} sx={botonPrincipalSx}>
          {saving ? <CircularProgress size={20} color="inherit" /> : "Guardar cambios"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarHistorialDialog;
